<section>
  <vdw-header
    [title]="getLabelTranslation()"
    [extraInformationTitle]="'PRODUCTION_ORDER.WEAVE_PLAN.DENT' | bmsTranslate: {value: zoneReference.startDent}"
    [svgIcon]="getIcon()"
    [canShowClose]="true"
    (closeEvent)="close()"
  ></vdw-header>
  <article class="dialog-content flex-row">
    <div class="flex-column gap-24">
      <div class="flex-row" *ngIf="canShowWarningMessages()">
        <div class="flex-column">
          <vdw-message-container [messages]="getWarningMessages()"></vdw-message-container>
        </div>
      </div>
      <div class="flex-row" *ngIf="canShowErrorMessages()">
        <div class="flex-column">
          <vdw-message-container [messages]="getErrorMessages()"></vdw-message-container>
        </div>
      </div>

      <div [formGroup]="editZoneForm" class="flex-row">
        <mat-form-field>
          <mat-label>{{ 'TEXTILE_DATA.CREEL.NUMBER_OF_DENTS' | bmsTranslate }}</mat-label>
          <input matInput vdwL10nDecimal type="number" [min]="1" [max]="maxAllowed" formControlName="technicalWidthInDents" />
          <mat-hint>
            {{ 'PRODUCTION_ORDER.WEAVE_PLAN.NUMBER_OF_UNUSED_DENTS' | bmsTranslate: {value: unusedDents} }}
          </mat-hint>

          <mat-error *ngIf="canShowErrorForFormControl('required', 'technicalWidthInDents')">
            {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
          </mat-error>

          <mat-error *ngIf="canShowErrorForFormControl('max', 'technicalWidthInDents')">
            {{ 'GENERAL.ERRORS.MAX_VALUE' | bmsTranslate: {max: maxAllowed} }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </article>
  <vdw-footer [locked]="!canEditZone()" chooseEventName="GENERAL.ACTIONS.EDIT" [centered]="true" [withChooseButton]="!isVerifying" [withCancelButton]="false">
    <button *ngIf="isVerifying" mat-flat-button color="primary" disabled>
      <div class="flex-row gap-12 flex-start-center">
        <span>{{ 'GENERAL.CALCULATING' | bmsTranslate }}</span>
        <mat-spinner [diameter]="16" [mode]="'indeterminate'"></mat-spinner>
      </div>
    </button>
  </vdw-footer>
</section>
